import * as THREE from 'three';
import { gsap } from "gsap";
import {EventEmitter} from '@billjs/event-emitter';
import {degrees_to_radians} from './Utils.js';

export default class Flamingo  extends EventEmitter{

  constructor(scene) {
    super();
    this.scene = scene;
    this.time = 0;
    this.timeCounter = 0;
    this.animating = true;
    this.userKey = null;
    this.userIndex = 0;
    this.target = new THREE.Vector3(0,0,0);
    this.environment = "water";
    this.mode = "flying";
    this.prompt = "";
    this.inScene = false;
    this.prevPos = new THREE.Vector3(0,0,0);
    this.prevRot = new THREE.Vector3(0,0,0);
    this.prevFloorPos = new THREE.Vector3(0,0,0);
    this.closeToOther = false;
    this.eatWait = true;

    this.BB = new THREE.Box3();
    this.cBB = new THREE.Box3();
    this.tempVec = new THREE.Vector3( 0, 0, 1 );
    this.frontPosition = new THREE.Object3D();
    this.originVec = new THREE.Vector3();
    this.destVec = new THREE.Vector3();
    this.directionVec = new THREE.Vector3();
    this.farVec = new THREE.Vector3();

    // movement vars
    this.moveSpeed = 0;
    this.moveDir = new THREE.Vector3(0, 0, -1);
    this.keyHash = {};
    this.raycaster = new THREE.Raycaster();
    this.targetRotation = Math.PI / 4;
    this.inOpeningSeq = true; // flag that begins in opening sequence flying in
    this.inFlyAbout = false; // to remove
    this.colorInMode = false;

    // for npc flamingos
    this.npcMode = "waiting"; // waiting, waiting_close, talking, flying_to_pool, pool_waiting, pool_dancing
    this.npcInteractionMode = "first";
    this.npcGuesses = 0;
    this.npcWordsGuessed = [];

    this.rotObj = new THREE.Object3D();

    this.velVec = new THREE.Vector3();
    //Mesh(new THREE.BoxGeometry(.25,.5,.25), new THREE.MeshStandardMaterial({color:0xff0000}));
    //this.scene.add(this.rotObj);


  }

  resetNpc(){
    this.npcMode = "waiting"; // waiting, waiting_close, talking, flying_to_pool, pool_waiting, pool_dancing
    this.npcInteractionMode = "first";
    this.npcGuesses = 0;
    this.npcWordsGuessed = [];
    this.makeGray();
  }

  addAsOtherUser(key,index){
    this.userKey = key;
    this.scene.add(this.group);
    this.userIndex = index;
    this.inScene = true;
  }

  removeAsOtherUser(){
    this.userKey = null;
    this.scene.remove(this.group);
    this.prompt = "";
  }

  updateTexture(texture, delay){
    setTimeout( function(){
      this.mesh.traverse((item) => {
        if(texture && item.isMesh && item.name == 'Leftwing'){
          item.material.map = texture;
          item.material.color = new THREE.Color(0xffffff);
          item.material.needsUpdating = true;
        }
      });
    }.bind(this),delay);

  }

  makeFlamingo(mesh, addToScene, wingColor, gltf,animations){
    this.group = new THREE.Group();
    this.group.name = "flamingo";
    this.mesh = gltf.scene;
    this.mixer = new THREE.AnimationMixer(gltf.scene);
    this.animationActions = {};
    this.activeAction = null;
    this.lastAction = null;
    this.wingColor = wingColor;

    this.helperbox = new THREE.BoxHelper( this.mesh, 0xffff00 );

    this.animationActions['walk'] = this.mixer.clipAction(animations['walk']);
    this.animationActions['idle'] = this.mixer.clipAction(animations['idle']);
    this.animationActions['jump'] = this.mixer.clipAction(animations['jump']);
    this.animationActions['fly'] = this.mixer.clipAction(animations['fly']);
    this.animationActions['dance'] = this.mixer.clipAction(animations['dance']);
    // this.animationActions['wait'] = this.mixer.clipAction(animations['wait']);


    this.mesh.scale.set(25,25,25);
    this.group.add(mesh);
    if(addToScene){
      this.scene.add(this.group);
      this.inScene = true;
    }

    let color = new THREE.Color(wingColor);//0xD55793);

    this.mesh.traverse((item) => {

      if(item.isMesh && item.name == "Corps" ){
        this.corps = item;
      }

      if(item.isMesh && item.name == "Tete" ){
        this.head = item;
      }

      if( item.name == "Patte_1_D"){
        this.legR = item;
      }else if( item.name == "Patte_1_G"){
        this.legL = item;
      }

      if(item.name == "Spring"){
        // item.material.color = new THREE.Color(0xCC798A);
      }else if(item.name == "Body"){
        item.material.color = new THREE.Color(0xDEBA5C0);
      }else if(item.name.includes("Bec") || item.name.includes("Oeil") ){
        item.material = new THREE.MeshToonMaterial({color:new THREE.Color(0x000000)});
      }else if(item.name.includes("Aile") ){
        item.material = new THREE.MeshToonMaterial({color:color});
      }else if(item.name.includes("Patte") || item.name.includes("Leg") || item.name.includes("Feet") ){
        item.material = new THREE.MeshToonMaterial({color:new THREE.Color(wingColor)});
        //0xF560A8
        // i fother
        // if(!addToScene){
        //   item.material = new THREE.MeshToonMaterial({color:new THREE.Color(0xDEBA5C0)});
        //
        // }
      }
      else{
        item.material = new THREE.MeshToonMaterial({color:new THREE.Color(0xDEBA5C0)});
      }

      if(item.name == "Bottom"){
        this.body = item;
        this.body.opos = new THREE.Vector3().copy(this.body.position);
      }
      if(item.name == "Rwing"){
        this.Rwing = item;

      }else if(item.name == "Lwing"){
        this.Lwing = item;
      }

      if(item.isMesh && item.name == 'Leftwing'){
        item.material.color = color;
      }

      if(item.name == 'Patte_Rotule_G'){
        this.kneeR = item;
      }
    });
      // let geometry = new THREE.SphereGeometry(.05,10,10);
      // let mat = new THREE.MeshStandardMaterial({color:0xff00ff});
      this.controlTarget = new THREE.Object3D();//new THREE.Mesh(geometry,new THREE.MeshStandardMaterial({color:0xff00ff}));


      // this.controlTarget = new THREE.Object3D();
      this.group.add(this.controlTarget);
      this.controlTarget.position.z += .5;
      this.controlTarget.position.y += .75;//.75;

      this.camTarget = new THREE.Object3D();//new THREE.Mesh(geometry,new THREE.MeshStandardMaterial({color:0xffff00}));//new THREE.Object3D();
      this.group.add(this.camTarget);
      this.camTarget.position.z -= 2.25;//3.25;//.5;
      this.camTarget.position.y += .75;//1.25;//.5;//
      //this.camTarget.position.x = .25;

      this.headPosition = new THREE.Object3D();
      this.group.add(this.headPosition);
      this.headPosition.position.z += .25;
      this.headPosition.position.y += .92;


      let geometry = new THREE.BoxGeometry(.25,.25,.25);
      let mat = new THREE.MeshStandardMaterial({color:0xff00ff, transparent:true,opacity:.5});
      this.box = new THREE.Object3D();//Mesh(geometry,mat);
      this.box.position.z -= .29 / 25;
      this.box.position.y += .625 / 25;

      this.corps.add(this.box);


      this.headP = new THREE.Object3D();// v
      this.headP.position.z -= .2 / 25;
      this.headP.position.y += .915 / 25;
      this.corps.add(this.headP);

      this.lookAhead = new THREE.Object3D();//Mesh(geometry,mat);
      this.lookAhead.position.x += .01;
      this.lookAhead.position.z -= .5 / 25;
      this.lookAhead.position.y += .95 / 25;
      this.corps.add(this.lookAhead);

      this.lookBack = new THREE.Object3D();//Mesh(geometry,mat);
      this.lookBack.position.x += 0;
      this.lookBack.position.z += 2/ 25;
      this.lookBack.position.y += 1 / 25;
      this.corps.add(this.lookBack);

      this.animationName = "fly";
      this.setAction(this.animationActions['fly'],'fly');

      this.followersPos = [];
      for(let i = 0; i < 3; i++){
        let pos = new THREE.Object3D();//new THREE.Mesh(geometry,mat);
        // pos.position.x += .01;
        pos.position.x = -.5;
        if(i % 2 == 0)
          pos.position.x = .5;
        pos.position.z -= i * .5;
        pos.position.y = 0;
        // pos.position.y += .95 / 25;
        this.group.add(pos);
        this.followersPos.push(pos);
      }

  }

  makeGray(){

    const gray = 0xDBBAD8;
    const grayDark = 0x9B8396;//A08BA0;

    this.mesh.traverse((item) => {



      if(item.name == "Body"){
        item.material.color = new THREE.Color(gray);
      }else if(item.name.includes("Bec") || item.name.includes("Oeil") ){
        item.material = new THREE.MeshToonMaterial({color:new THREE.Color(0x000000)});
      }else if(item.name.includes("Aile") ){
        item.material = new THREE.MeshToonMaterial({color:new THREE.Color(grayDark)});
      }else if(item.name.includes("Patte") || item.name.includes("Leg") || item.name.includes("Feet") ){
        item.material = new THREE.MeshToonMaterial({color:new THREE.Color(grayDark)});
      }
      else{
        item.material = new THREE.MeshToonMaterial({color:new THREE.Color(gray)});
      }


    });
  }

  doColorChangeMe(myNewColor){
    let hex, hexAlt;

    switch( myNewColor ){
      case 'red': hex = 0xFD3920; hexAlt = 0xFF681E;  break;
      case 'green': hex = 0x17C54F; hexAlt =  0xE1E634; break;
      case 'blue': hex = 0x8FBEE8; hexAlt = 0x0071CD; break;
      case 'orange': hex =0xFF681E; hexAlt = 0xFD3920;break;
      case 'purple': hex =0x773CBB; hexAlt = 0xE65EBD; break;
      case 'yellow': hex =0xF1E4B2 ;hexAlt = 0xFCD823; break;
      case 'pink': hex =0xE65EBD; hexAlt = 0xDEBA5C0; break;
      case 'default': hex = 0xee6e37; break;
    }


    if(myNewColor == "default"){
      this.mesh.traverse((item) => {
          if(item.name.includes("Bec") || item.name.includes("Oeil") ){
          // nothing
          }else if(item.name.includes("Aile") || item.name.includes("Patte") || item.name.includes("Leg") || item.name.includes("Feet") ){
            this.tweenColor(item.material,new THREE.Color(hex));
          }else{
            this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));
          }
        });
    }else{
      this.mesh.traverse((item) => {

        if(item.name.includes("Bec") || item.name.includes("Oeil") ){
          // nothing
        }else if(item.name.includes("Aile") ){
          item.material = new THREE.MeshToonMaterial({color:new THREE.Color(hexAlt)});
        }else if(item.name.includes("Patte") || item.name.includes("Leg") || item.name.includes("Feet") ){
          item.material = new THREE.MeshToonMaterial({color:new THREE.Color(hexAlt)});
        }else{
          item.material = new THREE.MeshToonMaterial({color:new THREE.Color(hex)});

        }

      });
    }


  }

  fadeToPink(){
    this.mesh.traverse((item) => {


      if(item.name.includes("Bec") || item.name.includes("Oeil") ){
        // nothing
      }else if(item.name.includes("Aile") || item.name.includes("Patte") || item.name.includes("Leg") || item.name.includes("Feet") ){
        //this.tweenColor(item.material,new THREE.Color(this.wingColor));
        this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));

      }else{
        //body
        this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));
      }


    });
  }

  fadeToPinkStrong(levelName = "community"){
    this.mesh.traverse((item) => {
      if(item.name.includes("Bec") || item.name.includes("Oeil") ){
        // nothing
      }else if(levelName == "spirit" && ( item.name.includes("Tail") || item.name.includes("Queue") ) ){
        this.tweenColor(item.material,new THREE.Color(0x000000));
      }else if(item.name.includes("Aile") || item.name.includes("Patte") || item.name.includes("Leg") || item.name.includes("Feet") ){
        this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));

      }else{
        // body
        // this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));
        this.tweenColor(item.material,new THREE.Color(this.wingColor));

      }


    });
  }

  tweenColor(material,final,duration=1,delay=0){
    if(!material) return;
    let initialColor = new THREE.Color().copy(material.color);
    return gsap.to(initialColor, {
      r: final.r,
      g: final.g,
      b: final.b,
      ease : 'sine.inOut',
      delay : delay,
      duration : duration,
      overwrite:true,
      onUpdate: function(){material.color = initialColor}
    });
  }

  makeBaby(){
    this.mesh.scale.set(16,12,16);
    this.mesh.traverse((item) => {


      if(item.isMesh && item.name == "Tete" ){
        item.scale.set(1.5,1,1);
      }


    });
  }

  updateColors(wingColor){
    let color = new THREE.Color(wingColor);//0xD55793);

    this.mesh.traverse((item) => {
      if(item.name.includes("Bec") || item.name.includes("Oeil") ){
        item.material = new THREE.MeshLambertMaterial({color:new THREE.Color(0x000000)});
      }else if(item.name.includes("Aile") ){
        item.material = new THREE.MeshLambertMaterial({color:color});
      }else if(item.name.includes("Patte") ){
        item.material = new THREE.MeshLambertMaterial({color:new THREE.Color(0xDEBA5C0)});

        // item.material = new THREE.MeshLambertMaterial({color:new THREE.Color(wingColor)});
      }else{
        item.material = new THREE.MeshLambertMaterial({color:new THREE.Color(0xDEBA5C0)});
      }
    });
  }

  setAction(toAction,name){

    if (toAction != this.activeAction) {

        this.lastAction = this.activeAction;
        this.activeAction = toAction;
        if(this.lastAction) this.lastAction.fadeOut(.5);

        this.fire("new_animation",name);
        this.animationName = name;

        if(this.activeAction){
          this.activeAction.reset();
          this.activeAction.fadeIn(1);
          this.activeAction.play();

        }

        if(name == "dance"){
          this.fire("started_dance");

        }else if(this.lastAction == this.animationActions['dance']){
          this.fire("stopped_dance");
          clearInterval(this.danceInterval);
        }

    }


  }

  isMoving(){
    if(this.mode != "bubble" && this.mode != "stop_moving"){
      if( this.keyHash.ArrowUp ||
        this.keyHash.ArrowLeft ||
        this.keyHash.ArrowRight ||
        this.keyHash.ArrowDown ||
        this.keyHash['w'] ||
        this.keyHash['a'] ||
        this.keyHash['s'] ||
        this.keyHash['d'] ||
        this.keyHash['W'] ||
        this.keyHash['A'] ||
        this.keyHash['S'] ||
        this.keyHash['D'] ||
        this.keyHash[' ']){
        this.mode = "moving";
        return true;
      }
    }
    return false;
  }

  startSittingAnimation(){

    if(this.waitTL){
      this.stopWaitingAnimation();
    }

    if(this.lastAction) this.lastAction.fadeOut(0);
    this.setAction(null,"sit");

    if(this.sitTL){
      this.sitTL.kill();
      this.lookTL.kill();
    }

    this.isSitting = true;

    let tempObj = new THREE.Object3D();
    tempObj.position.copy(this.group.position);
    tempObj.quaternion.copy(this.group.quaternion);
    tempObj.lookAt(new THREE.Vector3(0,this.group.position.y,0));

    gsap.to(this.group.rotation,{y:tempObj.rotation.y,duration:.25});
    this.sitTL = gsap.timeline({delay:.5});
    this.sitTL.to(this.legR.rotation,{x:degrees_to_radians(70),duration:.25});
    this.sitTL.to(this.legL.rotation,{x:degrees_to_radians(70),duration:.25},"<");
    this.sitTL.to(this.mesh.position,{y:-.15,duration:.35});

    this.lookTL = gsap.timeline({repeat:-1,repeatDelay:4});
    this.lookTL.to(this.corps.rotation,{y:degrees_to_radians(5),duration:.5});
    this.lookTL.to(this.corps.rotation,{y:degrees_to_radians(0),duration:.5,delay:1});
    this.lookTL.to(this.corps.rotation,{y:degrees_to_radians(-5),duration:.5,delay:1});
    this.lookTL.to(this.corps.rotation,{y:degrees_to_radians(0),duration:.5,delay:1});

    this.sittingMinTM = setTimeout(function(){
      this.sittingMinTM = null;
    }.bind(this),500)
  }

  endSittingAnimation(){

    if(this.isSitting && !this.sittingMinTM){
      this.isSitting = false;
      this.sitTL.to(this.mesh.position,{y:0,duration:.25, onComplete:function(){
        this.sitTL.kill();
        this.lookTL.kill();
        this.sitTL = null;
        this.legR.rotation.x = 0;
        this.legL.rotation.x = 0;
      }.bind(this)});
    }

  }

  startWaitingAnimation(){
    this.setAction(null,"wait");

    if(this.waitTL)
      this.waitTL.kill();

    this.waitTL = gsap.timeline({repeat: -1, repeatDelay: 2});

    // this.setAction(this.animationActions["wait"],"wait");
    // return;
    // this.waitTL.to(this.head.rotation,{y:degrees_to_radians(10),duration:.5, delay:.5});
    // this.waitTL.to(this.head.rotation,{y:0,duration:.5});

    // knee tap
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(10),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(0),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(10),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(0),duration:.25});

    // look up and down
    this.waitTL.to(this.corps.rotation,{x:degrees_to_radians(10),duration:.5},"+=.5");
    this.waitTL.to(this.corps.rotation,{x:0,duration:.5},"+=.5");

    // look to the side
    this.waitTL.to(this.corps.rotation,{y:degrees_to_radians(10),duration:.5});

    // knee tap
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(10),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(0),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(10),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(0),duration:.25});

    // look center
    this.waitTL.to(this.corps.rotation,{y:0,duration:.5});

    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(10),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(0),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(10),duration:.25});
    this.waitTL.to(this.kneeR.rotation,{x:degrees_to_radians(0),duration:.25});

    // look side
    this.waitTL.to(this.corps.rotation,{y:degrees_to_radians(-10),duration:.5},"+=.5");
    this.waitTL.to(this.corps.rotation,{y:0,duration:.5},"+=.5");

  }

  stopWaitingAnimation(){
    if(this.waitTL)
      this.waitTL.kill();
    this.waitTL = null;

    if(this.animationName == "wait"){
      this.setAction(null);
      this.animationName = "";
    }

  }

  doEatingAnimation(){
    if(this.lastAction)
      this.lastAction.fadeOut(0);
    this.setAction(null,"eat");
    this.eatTL = gsap.timeline({onComplete:function(){
         this.eatTL = null;
    }.bind(this)});
    this.eatTL.to(this.head.rotation,{x:degrees_to_radians(-120),duration:.5});
    this.eatTL.to(this.corps.rotation,{x:degrees_to_radians(-10),duration:.5},"<");
    this.eatTL.to(this.head.rotation,{x:0,duration:.5},"+1");
    this.eatTL.to(this.corps.rotation,{x:0,duration:.5},"<");

    this.eatWait = true;

    this.mesh.traverse((item) => {
      if(item.name.includes("Bec") || item.name.includes("Oeil") ){
        // nothing
      }
      // else if( item.name.includes("Tail") || item.name.includes("Queue")  ){
      //   this.tweenColor(item.material,new THREE.Color(0x000000));
      //   setTimeout( function(){this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));}.bind(this), 15000);
      //
      // }
      else if(item.name.includes("Aile") || item.name.includes("Patte") || item.name.includes("Leg") || item.name.includes("Feet") ){
        //this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));
        this.tweenColor(item.material,new THREE.Color(0xFD4DC6));
        setTimeout( function(){this.tweenColor(item.material,new THREE.Color(this.wingColor));}.bind(this), 15000);

      }else{
        // body
        this.tweenColor(item.material,new THREE.Color(0xFB89CB));
        setTimeout( function(){this.tweenColor(item.material,new THREE.Color(0xDEBA5C0));}.bind(this), 15000);
      }

    });

    setTimeout( function(){this.eatWait = false;}.bind(this), 20000);
  }

  setLookAt(lookAtPt){
    // if(this.isDoingLookAt){
    //   return;
    // }
    //
    // this.isDoingLookAt = true;
    this.rotObj.position.copy(this.group.position);
    // this.rotObj.quaternion.copy(this.group.quaternion);
    this.rotObj.lookAt(lookAtPt);


  }

  update(physicsCharacter,dt,tiles, collisions, selectables, water, floorCircle, clouds, allTiles){

    this.prevEnvironment = this.environment;

      //console.log("this.environment",this.environment);
    if(this.animating && this.group.position){

      this.time += dt;

      // update animations
      let timeMix = 2.5;
      switch (this.animationName) {
        case "idle": timeMix = 1; break;
        case "jump": timeMix = 2; break;
        case "fly": timeMix = 1; break;
        case "dance": timeMix = 1.5; break;

        default:

      }
      this.mixer.update(dt*timeMix);


      let hRad = .75 + Math.random() * 1;

      this.headPosition.position.x = .75 * Math.sin(this.time*1.5);
      this.headPosition.position.z = .75 * Math.cos(this.time*1.5);
      this.headPosition.position.y = .75 + .25 * Math.sin(this.time);

      let secondBB = this.BB.setFromObject(this.mesh);

      // check collision with words
      if(selectables){

        let didWordColl = false;
        selectables.forEach((item, i) => {

          if(item.parent.state == "tile-showing"){
            if(!didWordColl){
              this.mesh.updateMatrix();
              let firstBB = this.cBB.setFromObject(item);
              var collision = firstBB.intersectsBox(secondBB);
              this.originVec.copy(item.parent.position);
              this.destVec.copy(this.group.position);
              let distWord = this.originVec.distanceTo(this.destVec);

              if(distWord < .75){
                this.fire("selected_word",item);
                didWordColl = true;
              }else if(collision == true ){
                this.fire("selected_word",item);
                didWordColl = true;
              }
            }


          }

        });
      }

      if(water && !this.inOpeningSeq){
        let firstBB = this.cBB.setFromObject(water);
        var collision = firstBB.intersectsBox(secondBB);



        if(collision == true){
          if(this.environment != "water"){
            this.fire("entered_water");
          }
          this.environment = "water";
        }else if(this.group.position.y < .5){
          this.environment = "hover_water";
        }else{
          this.environment = "none";
        }

      }

      //  find ground position
      if(tiles && !this.inOpeningSeq){

          let frontPosition = this.frontPosition;
          this.frontPosition.position.copy(this.group.position);

          let origin = this.originVec.set(frontPosition.position.x,200,frontPosition.position.z);
          let dest = this.destVec.set(frontPosition.position.x,-200,frontPosition.position.z);
          let direction = this.directionVec;
          let far = this.farVec;

          let newArray = [];
          newArray.push(floorCircle);
          newArray.push(water);

          collisions.forEach((item, i) => {
            newArray.push(item);
          });



          this.raycaster.set(origin, direction.subVectors(dest, origin).normalize());
          this.raycaster.far = far.subVectors(dest, origin).length(); // comment this line to have an infinite ray

          let intersection = this.raycaster.intersectObject(tiles);
          let intersects = this.raycaster.intersectObjects(newArray);

          if(intersection.length > 0 ){
            const instanceId = intersection[ 0 ].instanceId;
            let tile = allTiles[instanceId];

            if(tile){
              let hDist = Math.abs(this.group.position.y - tile.scale.y/2);

              if(hDist < 1){
                this.currentTileIndex = instanceId;
                if(this.prevTileIndex != this.currentTileIndex && this.environment != "bridge"){

                  this.fire("on_tile", this.currentTileIndex);
                }
                this.environment = "hex";
              }else{
                this.currentTileIndex = null;

              }
            }



          }else{
            this.currentTileIndex = null;

            if(intersects.length == 0 && this.group.position.y < 1 && this.environment != null){
              // console.log("out of bounds");
              // this.fire("out_of_bounds");
              this.environment = null;
            }
          }


          if(intersects.length > 0){
            if(intersects[0].object == floorCircle && this.currentTileIndex == null){
              let dist = Math.abs(floorCircle.position.y - this.group.position.y);
              if(dist < .35){
                this.environment = "floor";
              }else{
                this.environment = "floor-hover";
              }
            }else if(intersects[0].object.name == "bench"){
              this.environment = "bench";
              if( this.prevEnvironment != "bench" ){
                this.enterBench = true;
                this.fire("enter_bench", intersects[0].object);
              }
            }else if(intersects[0].object.name == "bridge"){
              // this.environment = "bridge";

            }
          }

          if( this.prevEnvironment == "bench" && this.environment != "bench" ){
            this.fire("exit_bench");
            this.enterBench = false;


          }


          if(this.prevEnvironment != "floor" && this.environment == "floor"){
            this.fire("enter_floor");
          }

          if(this.prevTileIndex != null && this.prevTileIndex != this.currentTileIndex){
            this.fire("exit_tile", this.prevTileIndex);
            //this.prevTileIndex = null;
          }

          this.prevTileIndex = this.currentTileIndex;


        }

      if(this.mode == "moving"){

        this.moveFlySpeed = physicsCharacter.body.velocity.length() * .25;

        //this.group.position.y = (physicsCharacter.body.position.y-.35);// + (Math.sin(this.time* 2*Math.PI*2.0)+1)*this.moveFlySpeed*.1;//0.5;
        if(this.body){
          this.body.rotation.z =  -1.5 + (Math.sin(this.time* 2*Math.PI)*this.moveFlySpeed*.15);

        }

        // if(physicsCharacter && this.animationName != 'fly')
        //   this.group.rotation.y = this.lerpAngle( this.group.rotation.y,physicsCharacter.targetRotation  , 0.1);


      }

      if(this.animationName != 'fly'){
        //
        if(this.closeToOther && this.waitTL){
          this.stopWaitingAnimation();
        }

        if( (physicsCharacter.animation == 'idle' && this.eatTL) || (physicsCharacter.animation == 'idle' && this.waitTL) || (physicsCharacter.animation == 'idle' && this.sitTL) ){
          // do nothing
        }else{

          if(physicsCharacter.animation == "idle" && this.isTalking){
            this.setAction(this.animationActions['dance'],'dance');
          }
          else if(physicsCharacter.animation == "idle" && this.environment == "water" && !this.eatWait){
            this.doEatingAnimation();
            this.fire("did_eat");
          }
          else{
            //console.log("set action physics",physicsCharacter.animation);
            this.setAction(this.animationActions[physicsCharacter.animation],physicsCharacter.animation);
          }

        }

      }

      if(this.environment == "clouds"){
        this.environment = "none";
      }

      if(clouds && this.group.position.y > 5){
        // collision w clouds
        clouds.forEach((item, i) => {
          let firstBB = this.cBB.setFromObject(item);
          var collision = firstBB.intersectsBox(secondBB);
          if(collision == true){
            if(this.prevEnvironment != "clouds"){
              this.fire("entered_clouds",i);
            }
            this.environment = "clouds";
          }
        });

      }
    }

    if(this.isSitting == true && this.environment != "bench"){
      clearTimeout(this.sittingMinTM);
      this.sittingMinTM = null;
      this.endSittingAnimation();
    }

    if(this.environment != this.prevEnvironment){
      this.fire("changed_environment");
      if( this.prevEnvironment == "floor"){
        this.fire("exit_floor");
        // console.log("exit_floor");
      }
    }
  }

  setOtherUserAction(name){


    if(name == "none")
      name = null;

    if(name == this.animationName)
      return;

    switch(name){
      case 'idle':
        this.setAction(this.animationActions['idle'],name);
        break;
      case 'fly':
        this.setAction(this.animationActions['fly'],name);
        break;
      case 'walk':
        this.setAction(this.animationActions['walk'],name);
        break;
      case 'dance':
        this.setAction(this.animationActions['dance'],name);
        break;
      case 'sit':
          this.setAction(null,name);
          break;
      case 'eat':
          this.setAction(null,name);
          break;
      case null:
        this.setAction(null,name);
        break;
      default:
        this.setAction(null,name);
        break;
    }

  }

  getEnvironment(){
      if(!this.environment || this.environment == null){

        return "none";
      }
      return this.environment;
  }

  updateAsOther(dt,fPos,tiles){

    let vel = this.velVec.set(0,0,0).subVectors(this.prevPos, fPos);
    // let dist = this.velVec.length();

    this.timeCounter += dt;
    this.moveFlySpeed = vel * 4;

    this.group.quaternion.rotateTowards(this.rotObj.quaternion,.1);

    // animations update
    let timeMix = 2.5;
    switch (this.animationName) {
      case "idle": timeMix = 1; break;
      case "jump": timeMix = 2; break;
      case "fly": timeMix = 1; break;
      case "dance": timeMix = 1.5; break;

      default:

    }
    this.mixer.update(dt*timeMix);

    this.prevPos.copy(this.group.position);

  }

  lerpAngle( a, b, k ){
		if( a-b > Math.PI ) b += 2*Math.PI;
		if( b-a > Math.PI ) a += 2*Math.PI;

		return THREE.MathUtils.lerp( a, b, k ) % (2*Math.PI);
  }


}
